// extracted by mini-css-extract-plugin
export default {"divider":"ZO_8Za"};